import { render, staticRenderFns } from "./doDiningList.vue?vue&type=template&id=6b05c8c5&scoped=true"
import script from "./doDiningList.vue?vue&type=script&lang=js"
export * from "./doDiningList.vue?vue&type=script&lang=js"
import style0 from "./doDiningList.vue?vue&type=style&index=0&id=6b05c8c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b05c8c5",
  null
  
)

export default component.exports